import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sceneConstructorOwnBgMenu" }
const _hoisted_2 = { class: "sceneConstructorOwnBgMenu__upload" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "currentColor",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m193 260l-11-11 74-74 75 74-12 11-55-54 0 242-16 0 0-242z m206-76c0-2 1-3 1-4 0-64-53-116-117-116-46 0-86 27-105 66-8-4-17-6-26-6-30 0-55 23-59 52-36 12-61 46-61 86 0 50 40 90 90 90l91 0 0-16-91 0c-40 0-74-33-74-75 0-31 20-61 50-71l9-3 1-9c4-21 22-39 44-39 7 0 14 1 20 5l14 6 6-13c17-35 52-58 91-58 55 0 100 44 100 99 0 14 0 21 0 21l15 0c37 0 66 33 66 70 0 37-30 67-66 67l-101 0 0 16 101 0c45 0 82-37 82-83 0-45-35-85-81-85z" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SceneConstructorMenuItemIcon = _resolveComponent("SceneConstructorMenuItemIcon")!
  const _component_SceneConstructorMenuItem = _resolveComponent("SceneConstructorMenuItem")!
  const _component_SceneConstructorMenu = _resolveComponent("SceneConstructorMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SceneConstructorMenu, {
      showBackButton: true,
      showArrows: true,
      onGoBack: _cache[1] || (_cache[1] = () => _ctx.store.goTo('bgMenu'))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SceneConstructorMenuItem, {
          text: _ctx.$t('scene_constructor.upload_new')
        }, {
          default: _withCtx(() => [
            _createElementVNode("label", _hoisted_2, [
              _createVNode(_component_SceneConstructorMenuItemIcon, null, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createElementVNode("input", {
                type: "file",
                accept: "image/png, image/jpeg",
                onChange: _cache[0] || (_cache[0] = (e) => _ctx.setFile(e))
              }, null, 32)
            ])
          ]),
          _: 1
        }, 8, ["text"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.ownBackgrounds, (background) => {
          return (_openBlock(), _createBlock(_component_SceneConstructorMenuItem, {
            key: background.id,
            onClick: () => _ctx.selectBackground(background)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SceneConstructorMenuItemIcon, {
                backgroundImage: background.photo_box_url,
                checked: _ctx.state.selectedBackground && _ctx.state.selectedBackground.id == background.id
              }, null, 8, ["backgroundImage", "checked"])
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}